import React from "react";
import Select from "react-select";

export default function Select2({ label, ...props }) {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <div className="control">
        <div className="is-fullwidth select">
          <Select {...props} />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/form-fields/Select2.js